import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import ListaCSUModal from '../atendimento/ListaCSUModal';
import { resumoLista } from '../atendimento/listaLL';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Lista CSU na linha da CSU do Dashboard, ao lado do check, como a Lista LL (Adnéia, 03/11/2026):
// vermelho enquanto a lista do dia não foi importada, verde depois. O clique abre a lista (e a importação).
export default function BotaoListaCSU({ getAuthHeader, user }) {
  const [lista, setLista] = useState(null);
  const [aberta, setAberta] = useState(false);
  const authRef = useRef(getAuthHeader);
  authRef.current = getAuthHeader;

  const carregar = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/lista-csu`, { headers: authRef.current() });
      setLista(data);
    } catch {
      setLista(null);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const importada = !!lista?.importada;
  const r = resumoLista(lista?.chamados);
  const titulo = !lista
    ? 'Lista CSU: abrir'
    : importada
      ? `Lista CSU de hoje importada por ${lista.importado_por || '?'} às ${lista.importado_em_brt || '?'}: `
        + `${r.total} chamado(s), ${r.conferidos} conferido(s). Clique para abrir.`
      : 'Lista CSU de hoje ainda não importada: importe aqui a planilha dos chamados da CSU.';

  return (
    <>
      <button type="button" onClick={(e) => { e.stopPropagation(); setAberta(true); }} title={titulo}
        data-testid="btn-lista-csu"
        className={`flex-shrink-0 text-[11px] font-bold px-1.5 py-0.5 rounded border whitespace-nowrap ${importada
          ? 'bg-emerald-100 text-emerald-700 border-emerald-300 hover:bg-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800'
          : 'bg-red-100 text-red-700 border-red-300 hover:bg-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-800'}`}>
        {importada ? `Lista CSU ✓ ${r.conferidos}/${r.total}` : 'Lista CSU: importar'}
      </button>
      {aberta && (
        <ListaCSUModal getAuthHeader={getAuthHeader} user={user}
          onClose={() => { setAberta(false); carregar(); }} />
      )}
    </>
  );
}
